var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden)?_c('div',{staticClass:"generic-modal-container",class:{
    opened: !_vm.hidden,
    'bg-clip-padding bg-gray-50 backdrop-filter backdrop-blur-md bg-opacity-60': !_vm.hidden,
    opaque: _vm.isOpaque
}},[_c('div',{staticClass:"generic-modal",class:{smaller: _vm.smaller, larger: _vm.larger, medium: _vm.medium}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }